import {Pipe, PipeTransform} from "@angular/core";
 
@Pipe({name: 'cpfMask'})
export class CpfPipe implements PipeTransform{
 
    transform(value:string){
       if(value){
            value = value.toString();
            if(value.length === 11){
                return value.substring(0,3).concat(".")
                                     .concat(value.substring(3,6))
                                     .concat(".")
                                     .concat(value.substring(6,9))
                                     .concat("-")
                                     .concat(value.substring(9,11))
            } 
        }
        return value;
    }
}


// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/shared/pipes/cpf-mask.pipe.ts